import styled from 'styled-components';

import { Flag } from '@xing-com/flag';

const FlagWrapper = styled.div`
  line-height: 0;
`;

const FlagWithPointer = styled(Flag)`
  cursor: pointer;
  position: relative;
  z-index: 50;
`;

const UserFlagButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  margin: 0;
`;

export const Styled = {
  FlagWrapper,
  FlagWithPointer,
  UserFlagButton,
};
